import { Environment } from "../utils/Environment";

export const LOGIN_ROOT = `${Environment.getLoginUrl()}`;
export const API_ROOT = `${Environment.getApiUrl()}`;
export const DASHBOARD_API_ROOT = `${Environment.getDashboardApiUrl()}`;

// export const LOGIN_ROOT = `http://localhost:8000`;
// export const API_ROOT = `https://svwp-massmailer-service-westus-dev-app-service-route.apps.np.stratus.albertsons.com`;
// export const DASHBOARD_API_ROOT = `https://svwp-dashboard-service-westus-dev-app-service-route.apps.np.stratus.albertsons.com`;

//let locURL = (LOGIN_ROOT.includes(`dev`) || LOGIN_ROOT.includes(`localhost`)) ? `dev` : (LOGIN_ROOT.includes(`qa`) ? `qa` :
//(LOGIN_ROOT.includes(`perf`) ? `perf` : (LOGIN_ROOT.includes(`acceptance`) ? `perf` : (LOGIN_ROOT.includes(`stage`) ? `perf` : `prod`))));

export const apiUrl = {
	testUrl: `https://jsonplaceholder.typicode.com/todos`,
};
export const getUserSFKeyMap = {
	url: `${API_ROOT}/customercomments/getSalesForceIdEncryption`,
	method: `POST`,
};
export const getAccessDetail = {
	url: `${DASHBOARD_API_ROOT}/dashboard/getUserApplicationAccessDetails`,
	method: `POST`,
};
export const getSubscriptionKey = {
	url: `${LOGIN_ROOT}/api/getSubKey`,
	method: `GET`,
};
export const getSource = {
	url: `${API_ROOT}/massmailer/sources`,
	method: `GET`,
};
export const getReasonCode = {
	url: `${API_ROOT}/massmailer/reasoncode`,
	method: `GET`,
};
export const getTemplates = {
	url: `${API_ROOT}/massmailer/templates`,
	method: `GET`,
};

export const getStatusGrid = {
	url: `${API_ROOT}/massmailer/request/grid`,
	method: `GET`,
};

export const getNoOfRecipient = {
	url: `${API_ROOT}/massmailer/template/noofrecipient`,
	method: `POST`,
};

export const getTemplateContent = {
	url: `${API_ROOT}/massmailer/template`,
	method: `GET`,
};

export const getSaveRequest = {
	url: `${API_ROOT}/massmailer/template/request/save`,
	method: `POST`,
};
export const getSaveTemplate = {
	url: `${API_ROOT}/massmailer/template`,
	method: `POST`,
};
export const getEditTemplate = {
	url: `${API_ROOT}/massmailer/edittemplate`,
	method: `POST`,
};
export const getSendForApproval = {
	url: `${API_ROOT}/massmailer/template/request/approval`,
	method: `POST`,
};
export const getRequestDetails = {
	url: `${API_ROOT}/massmailer/request`,
	method: `GET`,
};
export const getAppoversGrid = {
	url: `${API_ROOT}/massmailer/approver/pending/request`,
	method: `GET`,
};
export const getAssignToMe = {
	url: `${API_ROOT}/massmailer/assigntome`,
	method: `POST`,
};
export const getApproveOrDecline = {
	url: `${API_ROOT}/massmailer/request`,
	method: `POST`,
};

export const getUseTemplateContent = {
	url: `${API_ROOT}/massmailer/template/usetemplate`,
	method: `GET`,
};
export const getDownloadDl = {
	url: `${API_ROOT}/massmailer/download/customerdlform`,
	method: `GET`,
};
export const cancelCurrRequest = {
	url: `${API_ROOT}/massmailer/request`,
	method: `DELETE`,
};
export const deleteRequest = {
	url: `${API_ROOT}/massmailer/template`,
	method: `DELETE`,
};

export const saveDl = {
	url: `${API_ROOT}/massmailer/predefined/saverequest`,
	method: `POST`,
};
export const getSearchResultCurrent = {
	url: `${API_ROOT}/massmailer/email/gridview`,
	method: `POST`,
};
export const sendMassEmail = {
	url: `${API_ROOT}/massmailer/send-mail`,
	method: `POST`,
};

export const scheduleMassEmail = {
	url: `${API_ROOT}/massmailer/schedule-mail`,
	method: `POST`,
};

export const getHelpDeskMessagesUrl = {
	url: `${API_ROOT}/ava/messages`,
	method: `GET`,
};

//soft delete will only archive the message
export const deleteMessageUrl = {
	url: `${API_ROOT}/ava/archiveMessage`,
	method: `PUT`,
};

export const createMessageUrl = {
	url: `${API_ROOT}/ava/message`,
	method: `POST`,
};

export const getDivision = {
	url: `${API_ROOT}/ava/divisions`,
	method: "GET",
};

//new apis
//to update Message : messages/7  - update message
export const updateMessageUrl = {
	url: `${API_ROOT}/ava/messages`,
	method: `PUT`,
};

//to archive message
export const getArchiveMessagesUrl = {
	url: `${API_ROOT}/ava/archiveMessages`,
	method: `POST`,
};

//to activate message
export const activateArchiveMessagesUrl = {
	url: `${API_ROOT}/ava/activeArchiveMessage`,
	method: `PUT`,
};

//messae type dropdown
export const getMessageTypesUrl = {
	url: `${API_ROOT}/ava/messageTypes`,
	method: `GET`,
};
